<mat-slide-toggle
  [checked]="checked"
  [disabled]="disabled || loading"
  [class.app-toggle-loading]="loading"
  (change)="checkedChange.emit($event.checked)"
>
  {{ label }}
</mat-slide-toggle>
